import { REALMS } from "@/lib/site";
import { Button } from "@/components/ui/button";
import { MessageSquare, Orbit } from "lucide-react";

export default function AISection({ onOpenChat }) {
  return (
    <section id="intelligence" className="py-20 lg:py-28 royal-radial grain relative overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-semibold mb-3">AI Intelligence · Phase VIII</p>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-emerald-50 uppercase tracking-tight">
              Five Realms. <span className="gold-gradient-text">One Constellation.</span>
            </h2>
            <p className="mt-6 text-slate-300 font-light leading-relaxed">
              Each realm is a distinct intelligence mode within the Luchii continuum. The Constellation
              Layer is where they connect — our metaphor for multi-model orchestration that powers the
              intelligent operation of the holding company.
            </p>
            <Button
              onClick={onOpenChat}
              data-testid="ai-section-chat-button"
              className="mt-8 bg-emerald-600 hover:bg-emerald-500 text-white rounded-full h-12 px-7 tracking-wide hover-emerald-glow border border-emerald-400/30"
            >
              <MessageSquare className="w-4 h-4 mr-2" /> Ask Luchii
            </Button>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {REALMS.map((r, i) => (
              <div
                key={r.name}
                data-testid={`realm-${r.name.toLowerCase()}`}
                className={`rounded-2xl border border-emerald-900/60 surface-panel p-5 hover-emerald-glow ${i === 4 ? "sm:col-span-2" : ""}`}
              >
                <div className="flex items-center gap-2 mb-2">
                  <Orbit className="w-4 h-4 text-gold" />
                  <span className="font-garamond text-lg text-emerald-50 tracking-wide">{r.name}</span>
                  <span className="text-[10px] uppercase tracking-widest text-slate-500">· {r.role}</span>
                </div>
                <p className="text-sm text-slate-400">{r.desc}</p>
                <p className="text-[11px] text-emerald-400/80 mt-2 tracking-wide">Use · {r.use}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
